
const VocabSideBar = {
    'summary' : ['Resumen', 'Summary'],
    'diagnosis' : ['Diagnóstico', 'Diagnosis'],
    'agenda' : ['Agenda', 'Agenda'],
    'dentistry' : ['Ontología', 'Dentistry'],
    'profile' : ['Perfil', 'Profile'],
    'emergency_contacts' : ['Contactos de emergencia', 'Emergency contacts'],
    'qualifications' : ['Estudios', 'Qualifications'],
    'settings' : ['Configuracion', 'Settings'],
    'privacy' : ['Privacidad', 'Privacy'],
    'addresses': ['Direcciones', 'Addresses'],
    'billing': ['Facturación', 'Billing'],
    'search': ['Busqueda', 'Search'],
  }
  export default VocabSideBar;
    